import { ProductType } from '../../types/product'

const productByType: Record<ProductType, string> = {
  meeting_room: 'meeting-rooms',
  day_pass: 'coworking',
  event_space: 'event-spaces',
  office: 'offices',
  suite: 'suites',
}

const typeByProduct = Object.fromEntries(
  Object.entries(productByType).map(([type, product]) => [product, type])
) as Record<string, ProductType>

export const serializeProductQuery = (types: ProductType[]): string | undefined => {
  const products = types.map((type) => productByType[type]).filter(Boolean)

  return products.length ? products.join(',') : undefined
}

export const parseProductQuery = (product?: string): ProductType[] | undefined => {
  if (!product) return undefined

  const types = product
    .split(',')
    .map((value) => typeByProduct[value])
    .filter((type): type is ProductType => Boolean(type))

  return types.length ? types : undefined
}
